import * as React from 'react';
import {ReactElement} from 'react';
import classnames from 'classnames';

import {replaceLineBreak, stringContainsHtml} from 'features/services/utils/string-helpers';
import {sanitizeHtml} from 'features/services/utils/sanitize-html';

import './style.scss';

interface Props {
    showMore?: boolean;
    newLines?: boolean;
    description: string | ReactElement;
    infoIcon?: boolean;
    id?: string;
    // Extra data-attribut på rotelementet, t.ex. källmärkning för sajtgranskaren
    dataAttributes?: Record<string, string>;
}

export const CollapsableText: React.FunctionComponent<Props> = ({showMore, newLines, description, infoIcon, id, dataAttributes}) => {
    const textClasses = classnames('collapsable-text', {
        'collapsable-text--show-more': showMore,
        'collapsable-text--info-icon': infoIcon,
    });

    const removeRogueHtml = (str: string) => {
        if(!str) return "";
        return  str.replace(/^(<br><br><div data-wrapper)/g, '<div data-wrapper');
    };

    return (
        typeof description === 'string'
            ? <div
                aria-hidden={!showMore}
                className={textClasses}
                id={id}
                {...dataAttributes}
                dangerouslySetInnerHTML={newLines ?
                    {__html: sanitizeHtml(stringContainsHtml(description) ?
                        removeRogueHtml(description) :
                        replaceLineBreak(description))} :
                    {__html: sanitizeHtml(description)}}
            />
            : <div
                aria-hidden={!showMore}
                className={textClasses}
                id={id}
                {...dataAttributes}
            >
                {description}
            </div>

    )
};
